import { Injectable } from '@angular/core';
import { EmployeeInfo } from '@typeDefs/home/responses/home';

@Injectable({
  providedIn: 'root',
})
export class EmployeeInfoService {
  private EmployeeInfo: EmployeeInfo;

  public setEmployeeInfo(value: EmployeeInfo): void {
    this.EmployeeInfo = value;
  }

  public getEmployeeInfo(): EmployeeInfo {
    return this.EmployeeInfo;
  }
}
